import React from 'react';

type BulletPointProps = {
    content: string[];
};

export const BulletPoints: React.FC<BulletPointProps> = ({ content }) => {
    return (
        <div className="bullet-points__container">
            {content.map((point, index) => (
                <p className="bullet-points__text" key={index}>
                    <span className="bullet-points__span">•</span>
                    {point}
                </p>
            ))}
        </div>
    );
};
